import React, { Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Paper, Typography } from '@mui/material';
import { useStateIfMounted } from 'use-state-if-mounted'
import { withRouter } from 'react-router-dom'
import {
    actualizarFC_35Estatus, agregarMapFC_35Accion, actualizarFC_35Solicitud,
    actualizarFC_35SolicitudMap, generarDocumentosFC_35,
    actualizarFC_35SolicitudModal
} from '../../../redux/DucksAtencionACliente/FC_35AtencionAClienteDucks';
import moment from 'moment'
import ToolBarPaginas from '../../App/ToolBarPaginas';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import { AcualizarFormatoAccion } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks'
import PaginacionAtencionAClientesComponent from '../../App/PaginacionAtencionAClientesComponent';
import TablaAtencionACliente from './TablaAtencionACliente';
import { obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado } from '../../../redux/DucksAtencionACliente/AtencionAClienteDucks';
import { obtenerTodasLasSolicitudesWithStatusEnviado } from '../../../redux/AtencionAClienteDucks'
import TablaDocumentacion from '../../App/TablaDocumentacion';
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import estilosFC35 from './AtencionAClientesFC_35Component.module.css'; { {/*Estilos para el componente*/ } }
import { v4 as uuidv4 } from 'uuid';
import FormularioDocumentacionFC_35 from '../../UsuarioAtencionACliente/FormularioFC35/FormularioDocumentacionFC_35';
import { crearMetricas } from '../../../redux/DuckMetricas/MetricasDuck';

const { useState, useEffect, useRef } = React;

const styleParaModalDeDocumentos = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1000,
    height: 600,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    color: 'black',
    p: 4,
    'overflowY': 'scroll',
};

const styleDevolver = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};
function FC_35Component(props) {

    const solicitud = useSelector(store => store.FC_35SolicitudAtencionACliente.data)
    let fc_35Map = useSelector(store => store.FC_35SolicitudAtencionACliente.fc_35Map)
    const usuario = useSelector(store => store.Usuario)
    const idUsuario = usuario.data.user[0].id
    let filesMap = useSelector(store => store.FC_35SolicitudAtencionACliente.filesMap)
    let fecha = solicitud.fechapropuestaactividad.substring(0, 10)
    const dispatch = useDispatch()
    const currentUser = useSelector(store => store.Usuario.data)
    const dataUser = useSelector(store => store.Usuario.user)

    let pagina1 = []
    let corteTipo = solicitud.tipoinstalacion?.split("/")
    pagina1.push(
        {
            id: uuidv4(), Campo: 'Fecha de visita propuesta', valor: fecha, idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.fechapropuestaactividad : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.fechapropuestaactividadcheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.fechapropuestaactividadcheck : false,
        }, {
        id: uuidv4(), Campo: 'Tipo de instalación', valor: corteTipo?.[1] == '1' ? 'Unidad de producción' : corteTipo?.[1] == '2' ? 'Unidad de envasado' : corteTipo?.[0] == 'Domicilio Fiscal' ? 'Domicilio Fiscal' : corteTipo?.[1] == '3' ? 'Unidad de almacen' : '', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
        observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.tipoinstalacion : '',
        correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.tipoinstalacioncheck : false,
        incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.tipoinstalacioncheck : false,
    },
        {
            id: uuidv4(), Campo: 'Nombre de responsable', valor: solicitud.nombreresponsable, idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.nombreresponsable : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.nombreresponsablecheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.nombreresponsablecheck : false,
        },
        {
            id: uuidv4(), Campo: 'Correo Electrónico', valor: solicitud.correoelectronico, idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.correoelectronico : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.correoelectronicocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.correoelectronicocheck : false,
        },
        {
            id: uuidv4(), Campo: 'Teléfono', valor: solicitud.telefono, idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.telefono : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.telefonocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.telefonocheck : false,
        },
        {
            id: uuidv4(), Campo: 'Domicilio Completo', valor: solicitud.domicilio, idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
            observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.domicilio : '',
            correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.domiciliocheck : false,
            incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.domiciliocheck : false,
        },
    )
    let paginaAjuste = []
    if (solicitud.ajusteetiquetado) {
        paginaAjuste.push(
            {
                id: uuidv4(), Campo: 'Ajuste de etiquetado', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.ajusteetiquetado : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.ajusteetiquetadocheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.ajusteetiquetadocheck : false,
                tipo: 'ajusteetiquetado'
            }
        )
        if (solicitud.ventanacional) {
            paginaAjuste.push(
                {
                    id: uuidv4(), Campo: 'Etiqueta para venta nacional', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.ventanacional : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.ventanacionalcheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.ventanacionalcheck : false,
                    tipo: 'ventanacional'
                }
            )
        }
        if (solicitud.ventaexportacion) {
            paginaAjuste.push(
                {
                    id: uuidv4(), Campo: 'Etiqueta para exportación', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.ventaexportacion : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.ventaexportacioncheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.ventaexportacioncheck : false,
                    tipo: 'ventaexportacion'
                }
            )
        }
        paginaAjuste.push(
            {
                id: uuidv4(), Campo: 'Descripción de servicio ajuste', valor: solicitud.servicioajuste, idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.servicioajuste : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.servicioajustecheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.servicioajustecheck : false,
                tipo: 'servicioajuste'
            }
        )
    }
    let [rowsajuste, setRowsAjuste] = React.useState(paginaAjuste)

    let paginaGestion = []
    if (solicitud.gestiontramites) {
        paginaGestion.push(
            {
                id: uuidv4(), Campo: 'Gestión de trámites ante el IMPI', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.gestiontramites : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.gestiontramitescheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.gestiontramitescheck : false,
                tipo: 'gestiontramites'
            }
        )
        if (solicitud.gestionautorizacion) {
            paginaGestion.push(
                {
                    id: uuidv4(), Campo: 'Gestión de autorización de uso de la denominación de origen mezcal', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.gestionautorizacion : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.gestionautorizacioncheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.gestionautorizacioncheck : false,
                    tipo: 'gestionautorizacion'
                }
            )
        }
        if (solicitud.gestionconvenio) {
            paginaGestion.push(
                {
                    id: uuidv4(), Campo: 'Gestión de convenio de corresponsabilidad ante el IMPI', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.gestionconvenio : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.gestionconveniocheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.gestionconveniocheck : false,
                    tipo: 'gestionconvenio'
                }
            )
        }
        if (solicitud.registromarca) {
            paginaGestion.push(
                {
                    id: uuidv4(), Campo: 'Registro de marca (clase 33) ante el IMPI', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.registromarca : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.registromarcacheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.registromarcacheck : false,
                    tipo: 'registromarca'
                }
            )
        }
        if (solicitud.renovacionmarca) {
            paginaGestion.push(
                {
                    id: uuidv4(), Campo: 'Renovación de marca', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.renovacionmarca : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.renovacionmarcacheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.renovacionmarcacheck : false,
                    tipo: 'renovacionmarca'
                }
            )
        }
        if (solicitud.licenciamarca) {
            paginaGestion.push(
                {
                    id: uuidv4(), Campo: 'Licencia de uso de marca', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.licenciamarca : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.licenciamarcacheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.licenciamarcacheck : false,
                    tipo: 'licenciamarca'
                }
            )
        }
        if (solicitud.transmicionderechos) {
            paginaGestion.push(
                {
                    id: uuidv4(), Campo: 'Cesión de derechos de marca', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.transmicionderechos : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.transmicionderechoscheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.transmicionderechoscheck : false,
                    tipo: 'transmicionderechos'
                }
            )
        }
        paginaGestion.push(
            {
                id: uuidv4(), Campo: 'Descripción de servicio de la gestión', valor: solicitud.serviciogestion, idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.serviciogestion : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.serviciogestioncheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.serviciogestioncheck : false,
                tipo: 'serviciogestion'
            }
        )
    }
    let [rowsgestion, setRowsGestion] = React.useState(paginaGestion)
    let paginaCofepris = []
    if (solicitud.paquetecofepris) {
        paginaCofepris.push(
            {
                id: uuidv4(), Campo: 'Paquete COFEPRIS-SAT', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.paquetecofepris : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.paquetecofeprischeck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.paquetecofeprischeck : false,
                tipo: 'paquetecofepris'
            }
        )
        if (solicitud.avisofuncionamiento) {
            paginaCofepris.push(
                {
                    id: uuidv4(), Campo: 'Aviso de funcionamiento COFEPRIS', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.avisofuncionamiento : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.avisofuncionamientocheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.avisofuncionamientocheck : false,
                    tipo: 'avisofuncionamiento'
                }
            )
        }
        if (solicitud.padronbebidas) {
            paginaCofepris.push(
                {
                    id: uuidv4(), Campo: 'Padrón de bebidas alcohólicas', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.padronbebidas : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.padronbebidascheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.padronbebidascheck : false,
                    tipo: 'padronbebidas'
                }
            )
        }
        if (solicitud.padronsectorial) {
            paginaCofepris.push(
                {
                    id: uuidv4(), Campo: 'Padrón sectorial de exportadores', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.padronsectorial : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.padronsectorialcheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.padronsectorialcheck : false,
                    tipo: 'padronsectorial'
                }
            )
        }
        if (solicitud.marbetes) {
            paginaCofepris.push(
                {
                    id: uuidv4(), Campo: 'Marbetes', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.marbetes : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.marbetescheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.marbetescheck : false,
                    tipo: 'marbetes'
                }
            )
        }
        paginaCofepris.push(
            {
                id: uuidv4(), Campo: 'Descripción de servicio de paquete Cofepris', valor: solicitud.serviciopaquete, idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.serviciopaquete : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.serviciopaquetecheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.serviciopaquetecheck : false,
                tipo: 'serviciopaquete'
            }
        )
    }
    let [rowscofepris, setRowsCofepris] = React.useState(paginaCofepris)

    {/*if (solicitud.analisispreliminar) {
        pagina1.push(
            {
                id: uuidv4(), Campo: 'Análsis preliminar de mezcal', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.analisispreliminar : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.analisispreliminarcheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.analisispreliminarcheck : false,
                tipo: 'analisispreliminar'
            }
        )
        if (solicitud.alcoholvolumen) {
            pagina1.push(
                {
                    id: uuidv4(), Campo: 'Alcohol volumen a 20 °C', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.alcoholvolumen : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.alcoholvolumencheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.alcoholvolumencheck : false,
                    tipo: 'alcoholvolumen'
                }
            )
        }
        if (solicitud.extractoseco) {
            pagina1.push(
                {
                    id: uuidv4(), Campo: 'Extracto seco', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.extractoseco : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.extractosecocheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.extractosecocheck : false,
                    tipo: 'extractoseco'
                }
            )
        }
        if (solicitud.alcoholesuperiores) {
            pagina1.push(
                {
                    id: uuidv4(), Campo: 'Alcoholes superiores', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.alcoholesuperiores : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.alcoholesuperiorescheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.alcoholesuperiorescheck : false,
                    tipo: 'alcoholesuperiores'
                }
            )
        }
        if (solicitud.metanol) {
            pagina1.push(
                {
                    id: uuidv4(), Campo: 'Metanol', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.metanol : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.metanolcheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.metanolcheck : false,
                    tipo: 'metanol'
                }
            )
        }
        if (solicitud.furfural) {
            pagina1.push(
                {
                    id: uuidv4(), Campo: 'Furfural', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.furfural : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.furfuralcheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.furfuralcheck : false,
                    tipo: 'furfural'
                }
            )
        }
        if (solicitud.aldehidos) {
            pagina1.push(
                {
                    id: uuidv4(), Campo: 'Aldehídos', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.aldehidos : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.aldehidoscheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.aldehidoscheck : false,
                    tipo: 'aldehidos'
                }
            )
        }
        if (solicitud.plomo) {
            pagina1.push(
                {
                    id: uuidv4(), Campo: 'Plomo', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.plomo : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.plomocheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.plomocheck : false,
                    tipo: 'plomo'
                }
            )
        }
        if (solicitud.arsenico) {
            pagina1.push(
                {
                    id: uuidv4(), Campo: 'Arsénico', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.arsenico : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.arsenicocheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.arsenicocheck : false,
                    tipo: 'arsenico'
                }
            )
        }
        pagina1.push(
            {
                id: uuidv4(), Campo: 'Datos de servicio de análisis preliminar', valor: solicitud.servicioanalisis, idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.servicioanalisis : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.servicioanalisischeck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.servicioanalisischeck : false,
                tipo: 'servicioanalisis'
            }
        )
    }*/}
    let paginasBitacora = []
    if (solicitud.solicitudbitacoras) {
        paginasBitacora.push(
            {
                id: uuidv4(), Campo: 'Solicitud de Bitácoras', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.solicitudbitacoras : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.solicitudbitacorascheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.solicitudbitacorascheck : false,
                tipo: 'solicitudbitacoras'
            }
        )
        if (solicitud.bitacoraproduccion) {
            paginasBitacora.push(
                {
                    id: uuidv4(), Campo: 'Bitácora de producción de Mezcal', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.bitacoraproduccion : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.bitacoraproduccioncheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.bitacoraproduccioncheck : false,
                    tipo: 'bitacoraproduccion'
                }
            )
        }
        if (solicitud.bitacoraenvasado) {
            paginasBitacora.push(
                {
                    id: uuidv4(), Campo: 'Bitácora de envasador de Mezcal', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.bitacoraenvasado : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.bitacoraenvasadocheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.bitacoraenvasadocheck : false,
                    tipo: 'bitacoraenvasado'
                }
            )
        }
        if (solicitud.bitacoracomercializador) {
            paginasBitacora.push(
                {
                    id: uuidv4(), Campo: 'Bitácora de comercializador de Mezcal', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.bitacoracomercializador : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.bitacoracomercializadorcheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.bitacoracomercializadorcheck : false,
                    tipo: 'bitacoracomercializador'
                }
            )
        }

        if (solicitud.comercializador) {
            paginasBitacora.push(
                {
                    id: uuidv4(), Campo: 'Comercializador', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.comercializador : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.comercializadorcheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.comercializadorcheck : false,
                    tipo: 'comercializador'
                }
            )
        }
        if (solicitud.serviciosolicitud) {
            paginasBitacora.push(
                {
                    id: uuidv4(), Campo: 'Datos de servicio de solicitud de bitacoras', valor: solicitud.serviciosolicitud, idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                    observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.serviciosolicitud : '',
                    correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.serviciosolicitudcheck : false,
                    incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.serviciosolicitudcheck : false,
                    tipo: 'serviciosolicitud'
                }
            )
        }
    }
    let [rowsbitacora, setRowsBitacora] = React.useState(paginasBitacora)
    let paginaOtros = []
    if (solicitud.otrosservicios) {
        paginaOtros.push(
            {
                id: uuidv4(), Campo: 'Otros servicios', valor: 'Si', idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.otrosservicios : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.otrosservicioscheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.otrosservicioscheck : false,
                tipo: 'otrosservicios'
            },
            {
                id: uuidv4(), Campo: 'Datos de otros servicios', valor: solicitud.serviciootros, idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
                observaciones: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.serviciootros : '',
                correcto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? !fc_35Map?.serviciootroscheck : false,
                incorrecto: JSON.stringify({}) !== JSON.stringify(fc_35Map) && JSON.stringify([]) !== JSON.stringify(fc_35Map) ? fc_35Map?.serviciootroscheck : false,
                tipo: 'serviciootros'
            }
        )
    }
    let [rowsotros, setRowsOtros] = React.useState(paginaOtros)
    let [rowspagina1, setRowsPagina1] = React.useState(pagina1)
    let pagina2 = []
    let nameid = 'DGPC'
    let filtro = solicitud.fc_35archivos.filter(anexos => anexos.nameid === nameid)
    const filtroMap = filesMap?.filter(anexo => anexo.idfc_35archivos === filtro[0]?.idfc_35archivos)
    pagina2.push({
        id: uuidv4(),
        observaciones: filtroMap?.[0] ? filtroMap?.[0]?.observacion : '',
        correcto: filtroMap?.[0] ? !filtroMap?.[0]?.estatuscheck : false,
        incorrecto: filtroMap?.[0] ? filtroMap[0]?.estatuscheck : false,
        fechaInicio: filtro?.[0]?.fechainicio ? filtro?.[0]?.fechainicio : '',
        fechaTermino: filtro?.[0]?.fechafin ? filtro?.[0]?.fechafin : '',
        estatus: filtro?.[0]?.estatus ? filtro?.[0]?.estatus : 'Agregar',
        idMap: filtroMap?.[0] ? filtroMap?.[0]?.idfc_35archivosmap : '',
        idfc_35archivos: filtro?.[0]?.idfc_35archivos,
        tabla: 'fc_35archivos', nombreId: 'idfc35_notificacionserviciosvar', idSolicitud: solicitud.idfc35_notificacionserviciosvar,
        nameid: nameid, nameDoc: 'Comprobante de pago'
    })
    let [rowspagina2, setRowsPagina2] = React.useState(pagina2)


    const handdleEditPrev = (objectProducto) => {
        const filtroGeneral = rowspagina1.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroAjuste = rowsajuste.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroGestion = rowsgestion.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroPaquete = rowscofepris.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroBitacoras = rowsbitacora.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroOtros = rowsotros.findIndex(anexo => anexo.id === objectProducto.id)
        const filtroDocumentacion = rowspagina2.findIndex(anexo => anexo.id === objectProducto.id)
        if (filtroGeneral !== -1) {
            rowspagina1[filtroGeneral].valor = objectProducto.valor
            rowspagina1[filtroGeneral].correcto = objectProducto.correcto
            rowspagina1[filtroGeneral].incorrecto = objectProducto.incorrecto
            rowspagina1[filtroGeneral].observaciones = objectProducto.observaciones
        }
        if (filtroAjuste !== -1) {
            rowsajuste[filtroAjuste].valor = objectProducto.valor
            rowsajuste[filtroAjuste].correcto = objectProducto.correcto
            rowsajuste[filtroAjuste].incorrecto = objectProducto.incorrecto
            rowsajuste[filtroAjuste].observaciones = objectProducto.observaciones
        }
        if (filtroGestion !== -1) {
            rowsgestion[filtroGestion].valor = objectProducto.valor
            rowsgestion[filtroGestion].correcto = objectProducto.correcto
            rowsgestion[filtroGestion].incorrecto = objectProducto.incorrecto
            rowsgestion[filtroGestion].observaciones = objectProducto.observaciones
        }
        if (filtroPaquete !== -1) {
            rowscofepris[filtroPaquete].valor = objectProducto.valor
            rowscofepris[filtroPaquete].correcto = objectProducto.correcto
            rowscofepris[filtroPaquete].incorrecto = objectProducto.incorrecto
            rowscofepris[filtroPaquete].observaciones = objectProducto.observaciones
        }
        if (filtroBitacoras !== -1) {
            rowsbitacora[filtroBitacoras].valor = objectProducto.valor
            rowsbitacora[filtroBitacoras].correcto = objectProducto.correcto
            rowsbitacora[filtroBitacoras].incorrecto = objectProducto.incorrecto
            rowsbitacora[filtroBitacoras].observaciones = objectProducto.observaciones
        }
        if (filtroOtros !== -1) {
            rowsotros[filtroOtros].valor = objectProducto.valor
            rowsotros[filtroOtros].correcto = objectProducto.correcto
            rowsotros[filtroOtros].incorrecto = objectProducto.incorrecto
            rowsotros[filtroOtros].observaciones = objectProducto.observaciones
        }
        if (filtroDocumentacion !== -1) {
            //rowspagina2[filtroDocumentacion].valor = objectProducto.valor
            rowspagina2[filtroDocumentacion].correcto = objectProducto.correcto
            rowspagina2[filtroDocumentacion].incorrecto = objectProducto.incorrecto
            rowspagina2[filtroDocumentacion].observaciones = objectProducto.observaciones
            rowspagina2[filtroDocumentacion].fechaInicio = objectProducto.fechaInicio
            rowspagina2[filtroDocumentacion].fechaTermino = objectProducto.fechaTermino
            rowspagina2[filtroDocumentacion].estatus = objectProducto.estatus
        }
    }
    const [paginaActiva, setPaginaActiva] = useStateIfMounted(1)
    const [paginas, setPaginas] = useStateIfMounted([1])
    const modoVerDetalle = useSelector(store => store.FC_35SolicitudAtencionACliente.modoVerDetalle)
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos solicitante'])
    const cambiarPagina = (pagina) => {
        setPaginaActiva(pagina)
    }

    React.useEffect(() => {
        let totalDePaginas = 1
        const nuevosApartados = ['Datos solicitante']
        if (solicitud.ajusteetiquetado) {
            totalDePaginas++
            let nombreApartado = 'Ajuste de Etiquetado'
            nuevosApartados.push(nombreApartado)
        }
        if (solicitud.gestiontramites) {
            totalDePaginas++
            let nombreApartado = 'Gestión de trámites ante el IMPI'
            nuevosApartados.push(nombreApartado)
        }
        if (solicitud.paquetecofepris) {
            totalDePaginas++
            let nombreApartado = 'Paquete COFEPRIS-SAT'
            nuevosApartados.push(nombreApartado)
        }
        if (solicitud.solicitudbitacoras) {
            totalDePaginas++
            let nombreApartado = 'Solicitud de Bitácoras'
            nuevosApartados.push(nombreApartado)
        }
        if (solicitud.otrosservicios) {
            totalDePaginas++
            let nombreApartado = 'Otros servicios'
            nuevosApartados.push(nombreApartado)
        }
        totalDePaginas++
        nuevosApartados.push('Documentación')
        let nuevasPaginas = []
        for (let index = 1; index <= totalDePaginas; index++) {
            nuevasPaginas.push(index)
        }
        setPaginas(nuevasPaginas)
        setNombresParaPaginas(nuevosApartados)
    }, [])
    const botonDevolverSolicitud = async () => {
        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_35Map) || JSON.stringify([]) === JSON.stringify(fc_35Map) || fc_35Map === null) {
            await agregarMapYActualizarFC_35()
            const idSolicitud = solicitud.idfc35_notificacionserviciosvar
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_35 = 9
            const tabla = tablaFC_35
            await dispatch(actualizarFC_35Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        } else {
            await actualizarMapYActualizarFC_35()
            const idSolicitud = solicitud.idfc35_notificacionserviciosvar
            const estatusNuevo = 5
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_35 = 9
            const tabla = tablaFC_35
            await dispatch(actualizarFC_35Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
            ))
        }
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')

    }
    const agregarMapYActualizarFC_35 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()
        principal.push({
            idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
            fechasolicitud: fechaSolicitudAceptada
        })
        let datosPricipalMap = []
        for (const dato of rowspagina1) {
            if (dato.Campo === 'Fecha de visita propuesta') datosPricipalMap.push({ fechapropuestaactividad: dato.observaciones, fechapropuestaactividadcheck: dato.incorrecto })
            if (dato.Campo === 'Tipo de instalación') datosPricipalMap.push({ tipoinstalacion: dato.observaciones, tipoinstalacioncheck: dato.incorrecto })
            if (dato.Campo === 'Nombre de responsable') datosPricipalMap.push({ nombreresponsable: dato.observaciones, nombreresponsablecheck: dato.incorrecto })
            if (dato.Campo === 'Correo Electrónico') datosPricipalMap.push({ correoelectronico: dato.observaciones, correoelectronicocheck: dato.incorrecto })
            if (dato.Campo === 'Teléfono') datosPricipalMap.push({ telefono: dato.observaciones, telefonocheck: dato.incorrecto })
            if (dato.Campo === 'Domicilio Completo') datosPricipalMap.push({ domicilio: dato.observaciones, domiciliocheck: dato.incorrecto })
        }
        for (const i in rowsajuste) {
            let { ...dato } = rowsajuste?.[i]
            if (dato.Campo === 'Ajuste de etiquetado') datosPricipalMap.push({ ajusteetiquetado: dato.observaciones, ajusteetiquetadocheck: dato.incorrecto })
            if (dato.Campo === 'Etiqueta para venta nacional') datosPricipalMap.push({ ventanacional: dato.observaciones, ventanacionalcheck: dato.incorrecto })
            if (dato.Campo === 'Etiqueta para exportación') datosPricipalMap.push({ ventaexportacion: dato.observaciones, ventaexportacioncheck: dato.incorrecto })
            if (dato.Campo === 'Descripción de servicio ajuste') datosPricipalMap.push({ servicioajuste: dato.observaciones, servicioajustecheck: dato.incorrecto })
        }
        for (const i in rowsgestion) {
            let { ...dato } = rowsgestion?.[i]
            if (dato.Campo === 'Gestión de trámites ante el IMPI') datosPricipalMap.push({ gestiontramites: dato.observaciones, gestiontramitescheck: dato.incorrecto })
            if (dato.Campo === 'Gestión de autorización de uso de la denominación de origen mezcal') datosPricipalMap.push({ gestionautorizacion: dato.observaciones, gestionautorizacioncheck: dato.incorrecto })
            if (dato.Campo === 'Gestión de convenio de corresponsabilidad ante el IMPI') datosPricipalMap.push({ gestionconvenio: dato.observaciones, gestionconveniocheck: dato.incorrecto })
            if (dato.Campo === 'Registro de marca (clase 33) ante el IMPI') datosPricipalMap.push({ registromarca: dato.observaciones, registromarcacheck: dato.incorrecto })
            if (dato.Campo === 'Renovación de marca') datosPricipalMap.push({ renovacionmarca: dato.observaciones, renovacionmarcacheck: dato.incorrecto })
            if (dato.Campo === 'Licencia de uso de marca') datosPricipalMap.push({ licenciamarca: dato.observaciones, licenciamarcacheck: dato.incorrecto })
            if (dato.Campo === 'Cesión de derechos de marca') datosPricipalMap.push({ transmicionderechos: dato.observaciones, transmicionderechoscheck: dato.incorrecto })
            if (dato.Campo === 'Descripción de servicio de la gestión') datosPricipalMap.push({ serviciogestion: dato.observaciones, serviciogestioncheck: dato.incorrecto })
        }
        for (const i in rowscofepris) {
            let { ...dato } = rowscofepris?.[i]
            if (dato.Campo === 'Paquete COFEPRIS-SAT') datosPricipalMap.push({ paquetecofepris: dato.observaciones, paquetecofeprischeck: dato.incorrecto })
            if (dato.Campo === 'Aviso de funcionamiento COFEPRIS') datosPricipalMap.push({ avisofuncionamiento: dato.observaciones, avisofuncionamientocheck: dato.incorrecto })
            if (dato.Campo === 'Padrón de bebidas alcohólicas') datosPricipalMap.push({ padronbebidas: dato.observaciones, padronbebidascheck: dato.incorrecto })
            if (dato.Campo === 'Padrón sectorial de exportadores') datosPricipalMap.push({ padronsectorial: dato.observaciones, padronsectorialcheck: dato.incorrecto })
            if (dato.Campo === 'Marbetes') datosPricipalMap.push({ marbetes: dato.observaciones, marbetescheck: dato.incorrecto })
            if (dato.Campo === 'Descripción de servicio de paquete Cofepris') datosPricipalMap.push({ serviciopaquete: dato.observaciones, serviciopaquetecheck: dato.incorrecto })
        }
        for (const i in rowsbitacora) {
            let { ...dato } = rowsbitacora?.[i]
            if (dato.Campo === 'Solicitud de Bitácoras') datosPricipalMap.push({ solicitudbitacoras: dato.observaciones, solicitudbitacorascheck: dato.incorrecto })
            if (dato.Campo === 'Bitácora de producción de Mezcal') datosPricipalMap.push({ bitacoraproduccion: dato.observaciones, bitacoraproduccioncheck: dato.incorrecto })
            if (dato.Campo === 'Bitácora de envasador de Mezcal') datosPricipalMap.push({ bitacoraenvasado: dato.observaciones, bitacoraenvasadocheck: dato.incorrecto })
            if (dato.Campo === 'Bitácora de comercializador de Mezcal') datosPricipalMap.push({ bitacoracomercializador: dato.observaciones, bitacoracomercializadorcheck: dato.incorrecto })
            if (dato.Campo === 'Comercializador') datosPricipalMap.push({ comercializador: dato.observaciones, comercializadorcheck: dato.incorrecto })
            if (dato.Campo === 'Datos de servicio de solicitud de bitacoras') datosPricipalMap.push({ serviciosolicitud: dato.observaciones, serviciosolicitudcheck: dato.incorrecto })
        }
        for (const i in rowsotros) {
            let { ...dato } = rowsotros?.[i]
            if (dato.Campo === 'Otros servicios') datosPricipalMap.push({ otrosservicios: dato.observaciones, otrosservicioscheck: dato.incorrecto })
            if (dato.Campo === 'Datos de otros servicios') datosPricipalMap.push({ serviciootros: dato.observaciones, serviciootroscheck: dato.incorrecto })
        }
        let obj_unidos = {}
        for (const i in datosPricipalMap) {
            obj_unidos = Object.assign(obj_unidos, datosPricipalMap[i])
        }
        obj_unidos.idfc35_notificacionserviciosvar = solicitud.idfc35_notificacionserviciosvar
        let archivosMap = []
        for (const anexo in rowspagina2) {
            archivosMap.push({
                estatuscheck: rowspagina2[anexo]?.incorrecto, observacion: rowspagina2[anexo]?.observaciones,
                idfc_35archivos: rowspagina2[anexo]?.idfc_35archivos,
            })
        }
        let archivos = []
        for (const anexo in rowspagina2) {
            let fechaInicio = ''
            let fechaFin = ''
            if (rowspagina2[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspagina2[anexo]?.fechaInicio).toISOString()
            else fechaInicio = null
            if (rowspagina2[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspagina2[anexo]?.fechaTermino).toISOString()
            else fechaFin = null
            archivos.push({
                fechainicio: fechaInicio, fechafin: fechaFin, idfc35_notificacionserviciosvar: rowspagina2[anexo]?.idSolicitud,
                idfc_35archivos: rowspagina2[anexo]?.idfc_35archivos,
            })
        }
        let formato = { solicitud: principal[0], archivos: archivos }
        let formatoMap = { solicitud: obj_unidos, archivosMap: archivosMap }
        await dispatch(agregarMapFC_35Accion(formatoMap))
        await dispatch(actualizarFC_35Solicitud(formato))
        return
    }
    const actualizarMapYActualizarFC_35 = async () => {
        let principal = []
        const fechaHoy = moment().format('YYYY-MM-DD')
        let fechaSolicitudAceptada = new Date(fechaHoy).toISOString()
        principal.push({
            idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
            fechasolicitud: fechaSolicitudAceptada
        })
        let datosPricipalMap = []
        for (const dato of rowspagina1) {
            if (dato.Campo === 'Fecha de visita propuesta') datosPricipalMap.push({ fechapropuestaactividad: dato.observaciones, fechapropuestaactividadcheck: dato.incorrecto })
            if (dato.Campo === 'Tipo de instalación') datosPricipalMap.push({ tipoinstalacion: dato.observaciones, tipoinstalacioncheck: dato.incorrecto })
            if (dato.Campo === 'Nombre de responsable') datosPricipalMap.push({ nombreresponsable: dato.observaciones, nombreresponsablecheck: dato.incorrecto })
            if (dato.Campo === 'Correo Electrónico') datosPricipalMap.push({ correoelectronico: dato.observaciones, correoelectronicocheck: dato.incorrecto })
            if (dato.Campo === 'Teléfono') datosPricipalMap.push({ telefono: dato.observaciones, telefonocheck: dato.incorrecto })
            if (dato.Campo === 'Domicilio Completo') datosPricipalMap.push({ domicilio: dato.observaciones, domiciliocheck: dato.incorrecto })
        }
        for (const i in rowsajuste) {
            let { ...dato } = rowsajuste?.[i]
            if (dato.Campo === 'Ajuste de etiquetado') datosPricipalMap.push({ ajusteetiquetado: dato.observaciones, ajusteetiquetadocheck: dato.incorrecto })
            if (dato.Campo === 'Etiqueta para venta nacional') datosPricipalMap.push({ ventanacional: dato.observaciones, ventanacionalcheck: dato.incorrecto })
            if (dato.Campo === 'Etiqueta para exportación') datosPricipalMap.push({ ventaexportacion: dato.observaciones, ventaexportacioncheck: dato.incorrecto })
            if (dato.Campo === 'Descripción de servicio ajuste') datosPricipalMap.push({ servicioajuste: dato.observaciones, servicioajustecheck: dato.incorrecto })
        }
        for (const i in rowsgestion) {
            let { ...dato } = rowsgestion?.[i]
            if (dato.Campo === 'Gestión de trámites ante el IMPI') datosPricipalMap.push({ gestiontramites: dato.observaciones, gestiontramitescheck: dato.incorrecto })
            if (dato.Campo === 'Gestión de autorización de uso de la denominación de origen mezcal') datosPricipalMap.push({ gestionautorizacion: dato.observaciones, gestionautorizacioncheck: dato.incorrecto })
            if (dato.Campo === 'Gestión de convenio de corresponsabilidad ante el IMPI') datosPricipalMap.push({ gestionconvenio: dato.observaciones, gestionconveniocheck: dato.incorrecto })
            if (dato.Campo === 'Registro de marca (clase 33) ante el IMPI') datosPricipalMap.push({ registromarca: dato.observaciones, registromarcacheck: dato.incorrecto })
            if (dato.Campo === 'Renovación de marca') datosPricipalMap.push({ renovacionmarca: dato.observaciones, renovacionmarcacheck: dato.incorrecto })
            if (dato.Campo === 'Licencia de uso de marca') datosPricipalMap.push({ licenciamarca: dato.observaciones, licenciamarcacheck: dato.incorrecto })
            if (dato.Campo === 'Cesión de derechos de marca') datosPricipalMap.push({ transmicionderechos: dato.observaciones, transmicionderechoscheck: dato.incorrecto })
            if (dato.Campo === 'Descripción de servicio de la gestión') datosPricipalMap.push({ serviciogestion: dato.observaciones, serviciogestioncheck: dato.incorrecto })
        }
        for (const i in rowscofepris) {
            let { ...dato } = rowscofepris?.[i]
            if (dato.Campo === 'Paquete COFEPRIS-SAT') datosPricipalMap.push({ paquetecofepris: dato.observaciones, paquetecofeprischeck: dato.incorrecto })
            if (dato.Campo === 'Aviso de funcionamiento COFEPRIS') datosPricipalMap.push({ avisofuncionamiento: dato.observaciones, avisofuncionamientocheck: dato.incorrecto })
            if (dato.Campo === 'Padrón de bebidas alcohólicas') datosPricipalMap.push({ padronbebidas: dato.observaciones, padronbebidascheck: dato.incorrecto })
            if (dato.Campo === 'Padrón sectorial de exportadores') datosPricipalMap.push({ padronsectorial: dato.observaciones, padronsectorialcheck: dato.incorrecto })
            if (dato.Campo === 'Marbetes') datosPricipalMap.push({ marbetes: dato.observaciones, marbetescheck: dato.incorrecto })
            if (dato.Campo === 'Descripción de servicio de paquete Cofepris') datosPricipalMap.push({ serviciopaquete: dato.observaciones, serviciopaquetecheck: dato.incorrecto })
        }
        for (const i in rowsbitacora) {
            let { ...dato } = rowsbitacora?.[i]
            if (dato.Campo === 'Solicitud de Bitácoras') datosPricipalMap.push({ solicitudbitacoras: dato.observaciones, solicitudbitacorascheck: dato.incorrecto })
            if (dato.Campo === 'Bitácora de producción de Mezcal') datosPricipalMap.push({ bitacoraproduccion: dato.observaciones, bitacoraproduccioncheck: dato.incorrecto })
            if (dato.Campo === 'Bitácora de envasador de Mezcal') datosPricipalMap.push({ bitacoraenvasado: dato.observaciones, bitacoraenvasadocheck: dato.incorrecto })
            if (dato.Campo === 'Bitácora de comercializador de Mezcal') datosPricipalMap.push({ bitacoracomercializador: dato.observaciones, bitacoracomercializadorcheck: dato.incorrecto })
            if (dato.Campo === 'Comercializador') datosPricipalMap.push({ comercializador: dato.observaciones, comercializadorcheck: dato.incorrecto })
            if (dato.Campo === 'Datos de servicio de solicitud de bitacoras') datosPricipalMap.push({ serviciosolicitud: dato.observaciones, serviciosolicitudcheck: dato.incorrecto })
        }
        for (const i in rowsotros) {
            let { ...dato } = rowsotros?.[i]
            if (dato.Campo === 'Otros servicios') datosPricipalMap.push({ otrosservicios: dato.observaciones, otrosservicioscheck: dato.incorrecto })
            if (dato.Campo === 'Datos de otros servicios') datosPricipalMap.push({ serviciootros: dato.observaciones, serviciootroscheck: dato.incorrecto })
        }
        let obj_unidos = {}
        for (const i in datosPricipalMap) {
            obj_unidos = Object.assign(obj_unidos, datosPricipalMap[i])
        }
        obj_unidos.idfc35_notificacionserviciosvar = solicitud.idfc35_notificacionserviciosvar
        obj_unidos.idfc35_notificacionserviciosvarmap = fc_35Map.idfc35_notificacionserviciosvarmap
        let archivosMap = []
        for (const anexo in rowspagina2) {
            archivosMap.push({
                estatuscheck: rowspagina2[anexo]?.incorrecto, observacion: rowspagina2[anexo]?.observaciones,
                idfc_35archivos: rowspagina2[anexo]?.idfc_35archivos, idfc_35archivosmap: rowspagina2[anexo]?.idMap,
            })
        }

        let archivos = []
        for (const anexo in rowspagina2) {
            let fechaInicio = ''
            let fechaFin = ''
            if (rowspagina2[anexo]?.fechaInicio.length > 0) fechaInicio = new Date(rowspagina2[anexo]?.fechaInicio).toISOString()
            else fechaInicio = null
            if (rowspagina2[anexo]?.fechaTermino.length > 0) fechaFin = new Date(rowspagina2[anexo]?.fechaTermino).toISOString()
            else fechaFin = null
            archivos.push({
                fechainicio: fechaInicio, fechafin: fechaFin, idfc35_notificacionserviciosvar: rowspagina2[anexo]?.idSolicitud,
                idfc_35archivos: rowspagina2[anexo]?.idfc_35archivos,
            })
        }
        let formato = { solicitud: principal[0], archivos: archivos }
        let formatoMap = { solicitud: obj_unidos, archivosMap: archivosMap }
        await dispatch(actualizarFC_35SolicitudMap(formatoMap))
        await dispatch(actualizarFC_35Solicitud(formato))
        return
    }
    const [openModalAceptar, setOpenModalAceptar] = React.useState(false);
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModalAceptar = () => setOpenModalAceptar(true);
    const handleCloseModalAceptar = () => setOpenModalAceptar(false);
    const modalComponentAceptar = () => {
        return (
            <div>
                <Modal
                    open={openModalAceptar}
                    onClose={handleCloseModalAceptar}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={styleParaModalDeDocumentos}>
                        <Typography id="modal-modal-title" variant="h6" component="h2" color="black !important" align='center'>
                            Para finalizar el trámite ingrese los siguientes datos
                        </Typography>
                        <FormularioDocumentacionFC_35
                            functionAcept={botonAceptarSolicitud}
                        ></FormularioDocumentacionFC_35>
                        <br />
                    </Box>
                </Modal>
            </div>

        )
    }
    const botonAceptarSolicitud = async (dataForm) => {
        await dispatch(actualizarLoadingApp_true())
        if (JSON.stringify({}) === JSON.stringify(fc_35Map) || JSON.stringify([]) === JSON.stringify(fc_35Map) || fc_35Map === null) {
            await agregarMapYActualizarFC_35()
        } else {
            await actualizarMapYActualizarFC_35()
        }
        const dataCliente = await dispatch(obtenerClienteByIdLogin(solicitud.idlogin))
        let dataMetricas = {
            estatus_procedencia: "Solicitudes Recibidas Procedentes",
            id_solicitud: "10", id_usuario: dataUser?.[0].idlogin,
            motivo: "Cargado automatico del sistema",
            fecha: moment().format('YYYY-MM-DD HH:mm:ss'),
            numero_cliente: solicitud?.numerocliente,
            numero_solicitud: dataForm?.numeroSolicitud, origen: "Sistema"
        }
        await dispatch(crearMetricas(dataMetricas))
        let informacionmodalaceptada = {
            numerosolicitudservicios: dataForm?.numeroSolicitud,
            numcertificadonom: dataForm?.numCertificadoNOM,
            numtraslado: dataForm?.numeroTraslado,
            otrosservicios: dataForm?.otrosServicios,
            fechainspeccion: dataForm?.fechaInspeccion,
            numplanevaluacion: dataForm?.numeroPlanEvaluacion,
            inspectorasignado: dataForm?.inspectorAsignado,
            credelcialinspector: dataForm?.credencialInspector,
            telefonoinspector: dataForm?.telefonoInspector
        }
        let actualizarinformacion = {
            idfc35_notificacionserviciosvar: solicitud.idfc35_notificacionserviciosvar,
            informacionmodalaceptada: informacionmodalaceptada
        }
        await dispatch(actualizarFC_35SolicitudModal(actualizarinformacion))

        await generarOficios(solicitud, dataCliente.payload.cliente[0], dataForm)
        const idSolicitud = solicitud.idfc35_notificacionserviciosvar
        const estatusNuevo = 4
        const idCliente = null
        const tablaFC_35 = 9
        const tabla = tablaFC_35
        await dispatch(actualizarFC_35Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: solicitud.folio } }
        ))
        const idRol = currentUser.user[0].rol
        if (idRol === 1) await dispatch(obtenerTodasLasSolicitudesWithStatusEnviado({ status: 4 }))
        else if (idRol === 2) await dispatch(obtenerTodasLasSolicitudesEjecuctivoWithStatusEnviado({ status: 4, revisor: dataUser[0]?.datoslogin.nombre + ' ' + dataUser[0]?.datoslogin.apellidos, idLogin: currentUser.user[0].id }))
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/AtencionAClientesComponent')
    }
    const generarOficios = async (solicitudFC_35, dataCliente, dataForm) => {
        const data = {
            tipoSolicitud: 'FC_35',
            solicitudFC_35,
            dataCliente,
        }
        const dataSolicitudInspeccion = {
            numeroSolicitud: dataForm.numeroSolicitud,
            numCertificadoNOM: dataForm.numCertificadoNOM,
            numeroTraslado: dataForm.numeroTraslado,
            otrosServicios: solicitudFC_35.serviciootros,
            fechaInspeccion: solicitudFC_35.fechapropuestaactividad,
            numeroPlanEvaluacion: dataForm.numeroPlanEvaluacion,
            inspectorAsignado: dataForm.inspectorAsignado,
            credencialInspector: dataForm.credencialInspector,
            telefonoInspector: dataForm.telefonoInspector,
            checkFabrica: false,
            checkProductor: false,
            checkNacional: false,
            checkEnvasadora: false,
            checkEnvasador: false,
            checkExportacion: false,
            checkGranel: false,
            checkComercializador: false,
            checkPromocion: false,
            checkProductoTerminado: false,
            checkTraslado: false,
            checkMaduracion: false,
        }
        data.dataSolicitudInspeccion = dataSolicitudInspeccion
        await dispatch(generarDocumentosFC_35(data))
    }
    const botonRegresar = async () => {
        props.history.push('/AtencionAClientesComponent')
        await dispatch(resetDataFC_35())
    }
    const [openModalDevolver, setOpenModalDevolver] = React.useState(false);
    const handleOpenModalDevolver = (params) => {
        setOpenModalDevolver(true)
    }
    const handleCloseModalDevolver = () => {
        setOpenModalDevolver(false)

    }
    const modalComponentDevolver = () => {
        return (
            <div>
                <Modal
                    open={openModalDevolver}
                    onClose={handleCloseModalDevolver}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    hideBackdrop={true}
                >
                    <Box sx={styleDevolver}>

                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>¡Advertencia!</center>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <p>Está a punto de devolver esta solicitud.
                                Las observaciones seran enviadas al cliente para correcciones.</p>
                            <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />

                        <div className='row'>
                            <div className='col-md-6'>
                                <button className='btn btn-outline-success' onClick={() => { botonDevolverSolicitud() }}>CONTINUAR</button>
                            </div>
                            <div className={` col-md-2`}>
                                <button className='btn btn-outline-danger' onClick={() => { handleCloseModalDevolver() }}>CANCELAR</button>
                            </div>
                        </div>

                    </Box>
                </Modal>
            </div>
        )
    }
    return (
        <Fragment>
            <div className='text-center'>
                <PaginacionAtencionAClientesComponent paginas={paginas} nombreParaPaginas={nombresParaPaginas} paginaActiva={paginaActiva} cambiarPagina={cambiarPagina} />
            </div>
            {
                nombresParaPaginas[paginaActiva - 1] === 'Datos solicitante' ?
                    <div className='row justify-content-center'>
                        <div className='col-10'>
                            <TablaAtencionACliente rows={rowspagina1} api={{ handdleEditPrev }}></TablaAtencionACliente>
                        </div>
                    </div> :
                    nombresParaPaginas[paginaActiva - 1] === 'Ajuste de Etiquetado' ?
                        <div className='row justify-content-center'>
                            <div className='col-10'>
                                <TablaAtencionACliente rows={rowsajuste} api={{ handdleEditPrev }}></TablaAtencionACliente>
                            </div>
                        </div>
                        :
                        nombresParaPaginas[paginaActiva - 1] === 'Gestión de trámites ante el IMPI' ?
                            <div className='row justify-content-center'>
                                <div className='col-10'>
                                    <TablaAtencionACliente rows={rowsgestion} api={{ handdleEditPrev }}></TablaAtencionACliente>
                                </div>
                            </div>
                            :
                            nombresParaPaginas[paginaActiva - 1] === 'Paquete COFEPRIS-SAT' ?
                                <div className='row justify-content-center'>
                                    <div className='col-10'>
                                        <TablaAtencionACliente rows={rowscofepris} api={{ handdleEditPrev }}></TablaAtencionACliente>
                                    </div>
                                </div>
                                :
                                nombresParaPaginas[paginaActiva - 1] === 'Solicitud de Bitácoras' ?
                                    <div className='row justify-content-center'>
                                        <div className='col-10'>
                                            <TablaAtencionACliente rows={rowsbitacora} api={{ handdleEditPrev }}></TablaAtencionACliente>
                                        </div>
                                    </div>
                                    :
                                    nombresParaPaginas[paginaActiva - 1] === 'Otros servicios' ?
                                        <div className='row justify-content-center'>
                                            <div className='col-10'>
                                                <TablaAtencionACliente rows={rowsotros} api={{ handdleEditPrev }}></TablaAtencionACliente>
                                            </div>
                                        </div>
                                        :
                                        <div className='row'>
                                            <div className='row justify-content-center'>
                                                <div className='col-12' style={{ marginLeft: '7%' }}>
                                                    <TablaDocumentacion rows={rowspagina2} api={{ handdleEditPrev }}></TablaDocumentacion>
                                                </div>
                                            </div>

                                            {modoVerDetalle ?
                                                <div className="row text-center">
                                                    <div className='col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12'>
                                                        <button type="submit" className={`btn ${estilosFC35.botonNaranjaRedondo}`} onClick={botonRegresar} >Regresar</button>
                                                    </div>
                                                </div>
                                                :
                                                <div className="row text-center mt-4 mb-4">
                                                    <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                        <button type="submit" className={`btn ${estilosFC35.botonNaranjaRedondo}`} onClick={handleOpenModalAceptar}>Aceptar solicitud</button>
                                                    </div>

                                                    <div className='col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6'>
                                                        <button type="submit" className={`btn ${estilosFC35.botonNaranjaRedondo}`} onClick={handleOpenModalDevolver}>Devolver solicitud</button>
                                                    </div>
                                                </div>
                                            }
                                        </div>
            }
            {modalComponentDevolver()}
            {modalComponentAceptar()}
        </Fragment>
    )
}
export default withRouter(FC_35Component)
